// "Remember me" unticked → the school session must end when the browser closes.
// A cookie without an expiry is dropped by the browser on close; its absence on boot ends the session.
const API = process.env.REACT_APP_BACKEND_URL;
const MARK = "msx_bs";

export const markBrowserSession = () => {
  document.cookie = `${MARK}=1; path=/; SameSite=Lax${window.location.protocol === "https:" ? "; Secure" : ""}`;
};

const hasMark = () => document.cookie.split("; ").some((c) => c === `${MARK}=1`);

export const enforceBrowserSession = () => {
  try {
    const sess = JSON.parse(localStorage.getItem("diag_session") || "null");
    if (!sess || sess.remember !== false || hasMark()) return;
    localStorage.removeItem("diag_session");
    if (sess.session_token) {
      fetch(`${API}/api/auth/logout`, { method: "POST", credentials: "include",
        headers: { Authorization: `Bearer ${sess.session_token}`, "x-session-token": sess.session_token } }).catch(() => {});
    }
  } catch { /* ignore */ }
};

export const revokeOtherSessions = async () => {
  let tok = null;
  try { tok = JSON.parse(localStorage.getItem("diag_session") || "null")?.session_token; } catch { /* ignore */ }
  const r = await fetch(`${API}/api/auth/sessions/revoke-others`, {
    method: "POST", credentials: "include", headers: tok ? { "x-session-token": tok } : {},
  });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(typeof d.detail === "string" ? d.detail : "Couldn't sign out other sessions");
  return d.revoked || 0;
};
